import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const AutocompleteContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
